import { z } from 'zod';

export const sessionPermissionsUpdatedNotificationSchema = z.object({
    type: z.literal('session/permissions-updated'),
    payload: z.object({
        practiceMemberId: z.string(),
    }),
});
